<template>
  <div class="w-gaodeMap">
    <transition name="fade">
      <div v-show="loading" class="mask">
        <div class="loader">
          <div class="face">
            <div class="circle"></div>
          </div>
          <div class="face">
            <div class="circle"></div>
          </div>
        </div>
      </div>
    </transition>
    <div id="WGMap"></div>
  </div>
</template>

<script>
  import WDAPI from '@/api/svolt/wiring-diagram';
  import {
    getInfo
  } from '@/utils/auth';
  import USERAPI from '@/api/user';
  import Vue from 'vue';
  export default {
    props: {
      projectStatus: ''
    },
    data() {
      return {
        loading: true,
        map: {},
        centerMap: [115.471907280816, 39.029174533421],
        zoom: 11,
        icon: '',
        groupId: '',
        systemId: '', //当前系统的id
        markList: [
          /* {
            position: [112.627434353299, 37.723819444445],
            data: [
              { label: '项目状态', value: '正常（投运）', href: '' },
              { label: '项目名称', value: '1MWh钠离子电池光储充智能微网系统', href: '' },
              { label: '项目编号', value: '86-030000-001', href: '' },
              { label: '项目类型', value: '集装箱储能产品', href: '' },
              { label: '详细地址', value: '清华大学山西清洁能源研究院', href: '' }
            ]
          },
          {
            position: [119.557970648872, 39.942944335938],
            data: [
              { label: '项目状态', value: '正常（投运）', href: '' },
              { label: '项目名称', value: '秦皇岛供电公司中小型项目', href: '' },
              { label: '项目编号', value: '86-066000-001', href: '' },
              { label: '项目类型', value: '中小型储能产品', href: '' },
              { label: '详细地址', value: '秦皇岛市海港区华山南路发茂电力安装公司', href: '' }
            ]
          },
          {
            position: [121.686607530382, 38.931844618056],
            data: [
              { label: '项目状态', value: '正常（投运）', href: '' },
              { label: '项目名称', value: '大连国网项目', href: '' },
              { label: '项目编号', value: '86-116001-001', href: '' },
              { label: '项目类型', value: '大型储能产品', href: '' },
              { label: '详细地址', value: '辽宁省大连市中山区港浦路139B-1号', href: '' }
            ]
          },
          {
            position: [115.479654134115, 38.836611056858],
            data: [
              { label: '项目状态', value: '正常（投运）', href: '' },
              { label: '项目名称', value: '信诚一期项目', href: '' },
              { label: '项目编号', value: '86-071000-001', href: '' },
              { label: '项目类型', value: '大型储能产品', href: '' },
              { label: '详细地址', value: '河北省保定市莲池区朝阳南大街2199号', href: '' }
            ]
          },
          {
            position: [115.479647352431, 38.836804199219],
            data: [
              { label: '项目状态', value: '正常（投运）', href: '' },
              { label: '项目名称', value: '信诚二期项目', href: '' },
              { label: '项目编号', value: '86-071000-002', href: '' },
              { label: '项目类型', value: '大型储能产品', href: '' },
              { label: '详细地址', value: '河北省保定市莲池区朝阳南大街2199号', href: '' }
            ]
          },
          {
            position: [115.471907280816, 39.029174533421],
            data: [
              { label: '项目状态', value: '正常（投运）', href: '' },
              { label: '项目名称', value: '蜂巢徐水传动智慧光储项目储能系统', href: '/#/svolt/project?projectId=86-072550-001' },
              { label: '项目编号', value: '86-072550-001', href: '' },
              { label: '项目类型', value: '中小型储能产品', href: '' },
              { label: '详细地址', value: '保定市徐水区法制街徐水传动厂区', href: '' }
            ]
          } */
        ],
        infoWindow: {}
      };
    },
    watch: {
      projectStatus(val) {
        this.searchProjects();
      }
    },
    methods: {
      setCenter(data) {
        let [a, b] = data.location.split(',');
        let lngLat = [Number(a), Number(b)];
        this.$nextTick(() => {
          this.centerMap = lngLat;
          this.map.setCenter(lngLat);
          this.map.setZoom(18);
          for (let i in this.markList) {
            if (this.markList[i].data[2].value == data.projectId) {
              var res = this.getInfoWindow(this.markList[i]);
              let tmpItem = {};
              tmpItem.position = this.markList[i].position;
              tmpItem.icon = this.getIcon(this.markList[i].type);
              let marker = new AMap.Marker(tmpItem);
              marker.setMap(this.map);
              res.open(this.map, marker.getPosition());
              let self = this;
              AMap.event.addListener(marker, 'mouseover', function() {
                res.open(self.map, marker.getPosition());
              });
              AMap.event.addListener(marker, 'mouseout', function() {
                self.closeWindows();
              });
              AMap.event.addListener(marker, 'click', function() {
                if (self.markList[i].data[1].isShow == 1) {
                  self.toProject(self.markList[i].data[2].value);
                } else {
                  self.$alert(
                    '<strong style="font-size: 15px;line-height: 24px;">用户未授权！</strong><br/><p style="font-size: 13px;line-height: 15px;">该项目数据不对其他用户开放，请见谅！</p>',
                    '温馨提示', {
                      dangerouslyUseHTMLString: true
                    }
                  );
                }
              });
            }
          }
        });
      },
      //获取项目列表
      async searchProjects() {
        let res = await WDAPI.searchProjects({
          groupId: this.groupId,
          projectName: '',
          projectStatus: this.projectStatus
        });
        if (res.data.code == 200) {
          this.markList = [];
          res.data.data.forEach((item, index) => {
            let val = {};
            let location = item.location.split(',');
            let href = item.status == 274 ? '/#/svolt/project?projectId=' + item.projectId : '';
            val.type = item.status;
            val.position = [Number(location[0]), Number(location[1])];
            val.data = [{
                label: '项目状态',
                value: item.statusName,
                href: ''
              },
              {
                label: '项目名称',
                value: item.projectName,
                href: href,
                isShow: item.isShow
              },
              {
                label: '项目编号',
                value: item.projectId,
                href: ''
              },
              {
                label: '详细地址',
                value: item.locationStr,
                href: ''
              }
              // { label: '储能容量', value: item.energyStorageCapacity + '（kWh）', href: '' },
              // { label: '储能功率', value: item.energyStoragePower + '（kW）', href: '' },
              // { label: '光伏容量', value: item.solarCapacity + '（kWp）', href: '' }
            ];
            if (index == 0) {
              let center = item.location.split(',');
              this.centerMap = [Number(center[0]), Number(center[1])];
            }
            this.markList.push(val);
          });
          this.$emit('complate', res.data.data);
          this.init();
        }
      },
      //获取信息窗口
      getInfoWindow(item) {
        let self = this;
        //实例化信息窗体
        return (this.infoWindow = new AMap.InfoWindow({
          isCustom: true, //使用自定义窗体
          content: this.setWindow(item).$el,
          offset: new AMap.Pixel(16, -30)
        }));
      },
      //设置窗口效果
      setWindow(item) {
        let self = this;
        var MyComponent = Vue.extend({
          template: '<div class="w-map-info-window">' +
            `<ul>
                        <li v-for="(it, index) in dt" :key="it.value">
                            <div v-if="index==0" class="header">
                                <span class="legend">
                                    <!-- <i v-if="it.code==274" class="el-icon-location normalLegend"></i>
                                    <i v-if="it.code==275" class="el-icon-location offlineLegend"></i>
                                    <i v-if="code==274" class="el-icon-location debugLegend"></i>
                                    <i v-if="it.code==276" class="el-icon-location buildLegend"></i> -->
                                    <img :src="${item.type}==274?'/static/images/svolt/normal.png':${item.type}==275?'/static/images/svolt/offLine.png':${item.type}==276?'/static/images/svolt/build.png':'/static/images/svolt/debug.png'" />
                                </span>
                                <span>{{it.value}}</span>
                                <span class="link" @click="goto([dt[1].isShow, dt[2].value])">进入>></span>
                            </div>
                            <div v-if="index!=0" class="content">
                                <span class="infoWindowLabel">{{it.label}}：</span>
                                <!-- <span class="a-link" v-if="it.href" @click="goto([dt[1].isShow, dt[2].value])">{{it.value}}</span>
                                <span v-else>{{it.value}}</span> -->
                                <span class="infoWindowValue">{{it.value}}</span>
                            </div>
                        </li>
                    </ul>` +
            '</div>',
          data() {
            return {
              dt: item.data
            };
          },
          methods: {
            goto(v) {
              if (v[0] == 1) {
                self.toProject(v[1]);
              } else {
                self.$alert(
                  '<strong style="font-size: 15px;line-height: 24px;">用户未授权！</strong><br/><p style="font-size: 13px;line-height: 15px;">该项目数据不对其他用户开放，请见谅！</p>',
                  '温馨提示', {
                    dangerouslyUseHTMLString: true
                  }
                );
              }
            }
          }
        });
        var component = new MyComponent().$mount();
        return component;
      },
      //获取锚点
      getIcon(type) {
        let url = '';
        switch (type) {
          case 274: {
            //投运
            url = '/static/images/svolt/normalMarker.png';
            break;
          }
          case 275: {
            //离线
            url = '/static/images/svolt/offlineMarker.png';
            break;
          }
          case 276: {
            //在建
            url = '/static/images/svolt/buildMarker.png';
            break;
          }
          case 300: {
            //调试
            url = '/static/images/svolt/debugMarker.png';
            break;
          }
        }
        return new AMap.Icon({
          size: new AMap.Size(30, 45),
          image: url,
          imageSize: new AMap.Size(30, 45)
        });
      },
      init() {
        this.map = new AMap.Map('WGMap', {
          resizeEnable: true, //是否监控地图容器尺寸变化
          zoom: this.zoom, //初始化地图层级
          center: this.centerMap, //初始化地图中心点
          mapStyle: 'amap://styles/ace0e7f8cbf48cbe0270b896dadfda1d' //设置地图的显示样式
        });
        this.addMarker();
        let self = this;
        this.map.on('click', self.closeWindows);
        this.map.on('complete', function() {
          self.loading = false;
        });
      },
      addMarker() {
        if (!this.map || this.markList.length == 0) {
          return false;
        }
        let self = this;
        let markers = [];
        this.markList.forEach((item, index) => {
          // if (index == 0) {
          // this.centerMap = item.position;
          // }
          item.data[0].code = item.type;
          var res = self.getInfoWindow(item);
          let tmpItem = {};
          tmpItem.position = item.position;
          tmpItem.icon = self.getIcon(item.type);
          let marker = new AMap.Marker(tmpItem);
          marker.setMap(self.map);
          //鼠标移入marker弹出自定义的信息窗体
          AMap.event.addListener(marker, 'mouseover', function() {
            res.open(self.map, marker.getPosition());
          });
          AMap.event.addListener(marker, 'mouseout', function() {
            self.closeWindows();
          });
          AMap.event.addListener(marker, 'click', function() {
            if (item.data[1].isShow == 1) {
              self.toProject(item.data[2].value);
            } else {
              self.$alert(
                '<strong style="font-size: 15px;line-height: 24px;">用户未授权！</strong><br/><p style="font-size: 13px;line-height: 15px;">该项目数据不对其他用户开放，请见谅！</p>',
                '温馨提示', {
                  dangerouslyUseHTMLString: true
                }
              );
            }
          });
          markers.push(marker);
        });
        var styles = [{
          url: '/static/images/svolt/clusterMarkerIcon.png',
          size: new AMap.Size(26, 44),
          offset: new AMap.Pixel(-16, -30),
          textColor: '#fff',
          textSize: 14
        }];
        AMap.plugin(['AMap.MarkerClusterer'], function() {
          let cluster = new AMap.MarkerClusterer(self.map, markers, {
            gridSize: 40,
            styles: styles
          });
        });
      },
      _renderClusterMarker(context) {
        var factor = Math.pow(context.count / count, 1 / 18);
        var div = document.createElement('div');
        var Hue = 180 - factor * 180;
        var bgColor = 'hsla(' + Hue + ',100%,50%,0.7)';
        var fontColor = 'hsla(' + Hue + ',100%,20%,1)';
        var borderColor = 'hsla(' + Hue + ',100%,40%,1)';
        var shadowColor = 'hsla(' + Hue + ',100%,50%,1)';
        div.style.backgroundColor = bgColor;
        var size = Math.round(30 + Math.pow(context.count / count, 1 / 5) * 20);
        div.style.width = div.style.height = size + 'px';
        div.style.border = 'solid 1px ' + borderColor;
        div.style.borderRadius = size / 2 + 'px';
        div.style.boxShadow = '0 0 1px ' + shadowColor;
        div.innerHTML = context.count;
        div.style.lineHeight = size + 'px';
        div.style.color = fontColor;
        div.style.fontSize = '14px';
        div.style.textAlign = 'center';
        context.marker.setOffset(new AMap.Pixel(-size / 2, -size / 2));
        context.marker.setContent(div);
      },
      //创建信息窗口
      createInfoWindow(title, content) {
        var info = document.createElement('div');
        info.className = 'custom-info input-card content-window-card';

        //可以通过下面的方式修改自定义窗体的宽高
        //info.style.width = "400px";
        // 定义顶部标题
        var top = document.createElement('div');
        var titleD = document.createElement('div');
        var closeX = document.createElement('img');
        top.className = 'info-top';
        titleD.innerHTML = title;
        closeX.src = 'https://webapi.amap.com/images/close2.gif';
        closeX.onclick = this.closeInfoWindow;

        top.appendChild(titleD);
        top.appendChild(closeX);
        info.appendChild(top);

        // 定义中部内容
        var middle = document.createElement('div');
        middle.className = 'info-middle';
        middle.style.backgroundColor = 'white';
        middle.innerHTML = content;
        info.appendChild(middle);

        // 定义底部内容
        var bottom = document.createElement('div');
        bottom.className = 'info-bottom';
        bottom.style.position = 'relative';
        bottom.style.top = '0px';
        bottom.style.margin = '0 auto';
        var sharp = document.createElement('img');
        sharp.src = 'https://webapi.amap.com/images/sharp.png';
        bottom.appendChild(sharp);
        info.appendChild(bottom);
        return info;
      },
      //关闭信息窗口
      closeWindows() {
        this.map.clearInfoWindow();
      },
      //调用用户资源权限跳转项目页面
      toProject(projectId) {
        let params = {
          projectId: projectId,
          resourceId: this.systemId
        };
        USERAPI.searchUserResources(params).then(res => {
          //保存权限模块
          localStorage.removeItem('ActiveProjectModule');
          let activeModule = {
            resourceIds: [],
            item: []
          };
          if (res.data.code == 200 && !res.data.errors) {
            let data = res.data.data;
            data.forEach(item => {
              activeModule.resourceIds.push(item.resourceId);
              activeModule.item.push({
                checked: item.checked,
                resourceId: item.resourceId,
                resourceNameShow: item.resourceNameShow,
                showOrder: item.showOrder
              });
              //增加二级展示
              if (item.children && item.children.length > 0) {
                item.children.forEach(n => {
                  activeModule.resourceIds.push(n.resourceId)
                  activeModule.item.push({
                    checked: n.checked,
                    resourceId: n.resourceId,
                    resourceNameShow: n.resourceNameShow,
                    showOrder: n.showOrder
                  });
                })
              }
            });
            localStorage.setItem('ActiveProjectModule', JSON.stringify(activeModule));
            this.$router.push({
              name: 'SvoltProject',
              query: {
                projectId: projectId
              }
            });
          }
        });
      }
    },
    mounted() {
      //  let self = this;
      // this.map.on('complete', function() {
      //   self.loading = false;
      // });
      // this.init();
    },
    created() {
      let info = JSON.parse(getInfo());
      this.systemId = 2; //localStorage.getItem('SystemId');
      this.groupId = info.groupId;
      this.searchProjects();
    },
    beforeDestroy() {
      this.map.off('click', this.closeWindows);
    }
  };
</script>

<style lang="scss">
  .w-gaodeMap {

    .fade-enter-active,
    .fade-leave-active {
      transition: opacity 0.5s;
    }

    .fade-enter,
    .fade-leave-active {
      opacity: 0;
    }

    .mask {
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0px;
      left: 0px;
      z-index: 20;
      // background: url('/static/images/system/bj.png');
    }

    width: 100%;
    height: 100%;
    position: absolute;
    top: 0px;
    left: 0px;
    z-index: 0;

    #WGMap {
      width: 100%;
      height: 100%;
      border: 1px solid #D9DBF3;
      border-radius: 10px;
    }
  }
</style>
<style lang="scss">
  .lineheight24 {
    line-height: 24px;
  }

  .loader {
    width: 20em;
    height: 20em;
    font-size: 10px;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 350px auto;
  }

  .loader .face {
    position: absolute;
    border-radius: 50%;
    border-style: solid;
    animation: animate 3s linear infinite;
  }

  .loader .face:nth-child(1) {
    width: 100%;
    height: 100%;
    color: gold;
    border-color: currentColor transparent transparent currentColor;
    border-width: 0.2em 0.2em 0em 0em;
    --deg: -45deg;
    animation-direction: normal;
  }

  .loader .face:nth-child(2) {
    width: 70%;
    height: 70%;
    color: lime;
    border-color: currentColor currentColor transparent transparent;
    border-width: 0.2em 0em 0em 0.2em;
    --deg: -135deg;
    animation-direction: reverse;
  }

  .loader .face .circle {
    position: absolute;
    width: 50%;
    height: 0.1em;
    top: 50%;
    left: 50%;
    background-color: transparent;
    transform: rotate(var(--deg));
    transform-origin: left;
  }

  .loader .face .circle::before {
    position: absolute;
    top: -0.5em;
    right: -0.5em;
    content: '';
    width: 1em;
    height: 1em;
    background-color: currentColor;
    border-radius: 50%;
    box-shadow: 0 0 2em, 0 0 4em, 0 0 6em, 0 0 8em, 0 0 10em, 0 0 0 0.5em rgba(255, 255, 0, 0.1);
  }

  @keyframes animate {
    to {
      transform: rotate(1turn);
    }
  }
</style>
<style lang="scss">
  .content-window-card {
    position: relative;
    box-shadow: none;
    bottom: 0;
    left: 0;
    width: auto;
    padding: 0;
  }

  .content-window-card p {
    height: 2rem;
  }

  .custom-info {
    border: solid 1px silver;
  }

  .w-map-info-window {
    min-width: 400px;
    // color: #a8ecff;
    height: auto;
    // padding: 0 20px 20px 20px;
    overflow: hidden;
    display: inline-block;
    background: rgba(255, 255, 255, 0.79);
    box-shadow: 0px 2px 13px 0px rgba(8, 33, 67, 0.5), 0px 0px 5px 0px #FFFFFF;
    // background: rgba(33, 60, 121, 0.45);
    // border: 1px solid #3d9bd4;
    border-radius: 6px;

    .header {
      background: #3B7CD5;
      color: #fff;
      font-weight: 600;
      height: 40px;
      padding: 4px 10px;
    }

    .link {
      float: right;
      line-height: 33px;
      margin-right: 10px;

      &:hover {
        cursor: pointer;
      }
    }

    .content {
      padding: 8px 20px;
    }

    .legend {
      line-height: 35px;
      // margin-right: -5px;

      img {
        width: auto;
        height: 21px;
        margin-top: -5px;
      }

      [class*=" el-icon-"],
      [class^=el-icon-] {
        font-size: 35px;
        vertical-align: middle;
      }

      .normalLegend:before {
        color: #5BC69C;
      }

      .debugLegend:before {
        color: #EB6271;
      }

      .buildLegend:before {
        color: #FFDD46;
      }

      .offlineLegend:before {
        color: #C8D5E9;
      }
    }

    ul {
      li {
        font-size: 14px;
        // padding: 8px 0px;
        line-height: 20px;

        .infoWindowLabel {
          color: #9197A4;
          font-weight: 600;
        }

        .infoWindowValue {
          color: #3C3D3F;
          font-weight: 600;
        }

        .a-link {
          color: #00dde0;

          &:hover {
            cursor: pointer;
          }
        }
      }
    }
  }

  div.info-top {
    position: relative;
    background: none repeat scroll 0 0 #f9f9f9;
    border-bottom: 1px solid #ccc;
    border-radius: 5px 5px 0 0;
  }

  div.info-top div {
    display: inline-block;
    color: #333333;
    font-size: 14px;
    font-weight: bold;
    line-height: 31px;
    padding: 0 10px;
  }

  div.info-top img {
    position: absolute;
    top: 10px;
    right: 10px;
    transition-duration: 0.25s;
  }

  div.info-top img:hover {
    box-shadow: 0px 0px 5px #000;
  }

  div.info-middle {
    font-size: 12px;
    padding: 10px 6px;
    line-height: 20px;
  }

  div.info-bottom {
    height: 0px;
    width: 100%;
    clear: both;
    text-align: center;
  }

  div.info-bottom img {
    position: relative;
    z-index: 104;
  }

  .info-middle img {
    float: left;
    margin-right: 6px;
  }

  .amap-logo {
    display: none;
    opacity: 0 !important;
  }

  .amap-copyright {
    opacity: 0 !important;
  }
</style>
<style>
  .amap-info-content {
    background: transparent !important;
  }

  div.info-top {
    display: none;
  }

  div.info-bottom {
    display: none;
  }

  div.info-middle {
    background: transparent !important;
  }

  div.content-window-card {
    background: transparent !important;
    border: 0px;
    bottom: 0px;
  }
</style>
<style lang="scss">
  div.el-message-box {
    background-color: #0f1b4a !important;
    border-color: #0f1b4a;
    width: 450px;
  }

  div.el-message-box__header {
    border-bottom: 1px solid #000;
  }

  div.el-message-box__title {
    text-align: center;
  }

  div.el-message-box__title span {
    font-size: 14px;
    display: inline-block;
  }

  div.el-message-box__title,
  div.el-message-box__message {
    color: #fff;
  }
</style>


// WEBPACK FOOTER //
// src/views/svolt/components/w-gaode-map.vue